import getStatusOptions from './getStatusOptions';

export default function getStatusOption({ t, status }) {
  return getStatusOptions({ t }).find(({ value }) => value === status);
}
